"use client"

import { useState } from "react"

interface AcknowledgeButtonProps {
  alertId: string
  acknowledged: boolean
}

export function AcknowledgeButton({
  alertId,
  acknowledged: initialAcknowledged,
}: AcknowledgeButtonProps) {
  const [acknowledged, setAcknowledged] = useState(initialAcknowledged)
  const [loading, setLoading] = useState(false)

  async function toggle() {
    setLoading(true)
    try {
      const res = await fetch(`/api/alerts/${alertId}/acknowledge`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ acknowledged: !acknowledged }),
      })
      if (res.ok) {
        setAcknowledged(!acknowledged)
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <button
      type="button"
      onClick={toggle}
      disabled={loading}
      className="inline-flex h-5 w-5 items-center justify-center rounded border border-border transition-colors hover:bg-accent disabled:opacity-50"
      title={acknowledged ? "Mark as unacknowledged" : "Acknowledge alert"}
    >
      {acknowledged && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 16 16"
          fill="currentColor"
          className="h-3.5 w-3.5 text-green-500"
        >
          <path
            fillRule="evenodd"
            d="M12.416 3.376a.75.75 0 0 1 .208 1.04l-5 7.5a.75.75 0 0 1-1.154.114l-3-3a.75.75 0 0 1 1.06-1.06l2.353 2.353 4.493-6.74a.75.75 0 0 1 1.04-.207Z"
            clipRule="evenodd"
          />
        </svg>
      )}
    </button>
  )
}
